import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import { List, SearchInput, useListContext, TopToolbar, FilterButton, SortButton, useGetResourceLabel, TextInput, BooleanInput } from "react-admin";
import MobileGrid from "./MobileGrid";
import CoreCreateButton from "../../../../shared/components/core/CoreCreateButton";
import { samplingLocationExporter } from "../../../../shared/utilities/adminExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_SAMPLING_LOCATION_C" />
        {/* CHANGEME */}
        <SortButton fields={['name']} />
        <FilterButton />
        <SacopExportButton exporter={samplingLocationExporter} />
    </TopToolbar>
);

const samplingLocationFilters = [
    <SearchInput source="q" alwaysOn />,

    <BooleanInput source="active" />,
    <TextInput source="name" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    return (
        <MobileGrid  {...listContext} />
    );
}

const SamplingLocationList = () => {
    return (<List
        filterDefaultValues={ { active: true }}
        sort={{ field: 'name', order: 'DESC' }}
        perPage={25}
        filters={samplingLocationFilters}
        actions={<ListActions />}
        exporter={samplingLocationExporter}
        title="Lista de Lugares"
        
    >
        <TabbedDatagrid />
    </List>);
};

export default SamplingLocationList;
